// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__dAT2k","header":"Card_header__1qsoq","headerText":"Card_headerText__upHZZ"};